<!--
Author: TangChen
Date: 2019-01-03
Desc: 购买定投基金，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-wisdom-buy bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/gfund' }">
                    基金定投
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <el-radio-group v-if="showList" v-model="wisdomFund" class="wisdom-con">
            <el-radio label="" class="tit" :disabled="true">
                <el-row class="wisdom-list">
                    <el-col :span="3">
                        类别
                    </el-col>
                    <el-col :span="6">
                        基金名称
                    </el-col>
                    <el-col :span="4">
                        收费方式
                    </el-col>
                    <el-col :span="4">
                        参考指数
                    </el-col>
                    <el-col :span="4">
                        均线
                    </el-col>
                    <el-col :span="3">
                        级差
                    </el-col>
                </el-row>
            </el-radio>
            <template v-if="recommendFund.length > 0">
                <el-radio v-for="(item,index) in recommendFund" :key="index" :label="item.fundcode">
                    <div class="code">
                        <i>TOP{{ index+1 }}</i>
                    </div>
                    <el-row class="wisdom-list">
                        <el-col :span="3" class="k-text-flow">
                            {{ item.title }}
                        </el-col>
                        <el-col :span="6">
                            {{ item.fundname+'('+(item.fundcode === "515981" ? "515980" : item.fundcode)+')' }}
                        </el-col>
                        <el-col :span="4">
                            {{ $cache.getDict('130000',item.sharetype) }}
                        </el-col>
                        <el-col :span="4">
                            {{ $cache.getDict('110033',item.indextype) }}
                        </el-col>
                        <el-col :span="4">
                            {{ $cache.getDict('110211',item.policyvalue) }}
                        </el-col>
                        <el-col :span="3">
                            {{ $cache.getDict('110270',item.investmove) }}
                        </el-col>
                    </el-row>
                </el-radio>
            </template>
            <el-radio label="10">
                <el-row class="wisdom-list my-wisdom">
                    <el-col :span="3">
                        自选产品
                    </el-col>
                    <el-col :span="6">
                        <el-select v-model="fundCode" placeholder="请选择">
                            <el-option
                                v-for="item in fundArr"
                                :key="item.fundcode"
                                :label="item.fundname"
                                :value="item.fundcode"
                            >
                                {{ item.fundname+'('+(item.fundcode === "515981" ? "515980" : item.fundcode)+')' }}
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col v-cloak :span="4">
                        {{ selFund.sharetype?$cache.getDict('130000',selFund.sharetype):'未知' }}
                    </el-col>
                    <el-col :span="4">
                        <el-select v-model="setFund.indextype">
                            <el-option
                                v-for="item in indexType"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-col>
                    <el-col :span="4">
                        <el-select v-model="setFund.policyvalue">
                            <el-option
                                v-for="item in subjectIndex"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-col>
                    <el-col :span="3">
                        <el-select v-model="setFund.investmove">
                            <el-option
                                v-for="item in investMove"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-col>
                </el-row>
            </el-radio>
        </el-radio-group>
        <div v-show="selFund.fundcode" class="line-padding" />
        <plan-buy
            v-if="selFund.fundcode"
            :wisdom="true"
            :general-fund="selFund"
            :set-fund="setFund"
            v-on:back-fn="backFn"
        />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import planBuy from "@/components/fund/planBuy";
export default {
    name: "WisdomBuy",
    components: {
        planBuy
    },
    mixins: [mixin],
    data () {
        return {
            wisdomFund: "", // 智慧定投选择
            fundArr: [], // 所有智慧定投基金
            indexType: [],
            subjectIndex: [],
            investMove: [],
            fundCode: "",
            stValue: "A",
            selFund: {},
            setFund: {
                indextype: "0",
                policyvalue: "03",
                investmove: "10"
            },
            recommendFund: [],
            showList: true
        };
    },
    watch: {
        // 普通智慧定投获取选中
        fundCode (val) {
            if (this.wisdomFund === "10") {
                this.getSelFund(this.fundArr, val);
            } else {
                this.wisdomFund = "10";
            }
        },
        // 推荐智慧定投获取选中
        wisdomFund (val) {
            if (val !== "10") {
                this.getSelFund(this.recommendFund, val, true);
            } else {
                if (!this.fundCode) {
                    this.fundCode = this.fundArr[0].fundcode;
                }
                this.getSelFund(this.fundArr, this.fundCode);
            }
        }
    },
    mounted () {
        this.getRecommendFund();
        this.indexType = this.$cache.getDict("110033");
        this.subjectIndex = this.$cache.getDict("110211");
        this.investMove = this.$cache.getDict("110270");
    },
    methods: {
        // 查询智能定投基金信息
        getGeneralFund () {
            const _this = this;
            const _x = {
                flag: "1",
                pagecount: "1000",
                pageoffset: "0"
            };
            this.$util.request("trade/fund/list", _x).then(res => {
                if (res.data) {
                    _this.fundArr = res.data[0];
                    if (_this.fundArr.length === 0 && _this.recommendFund.length === 0) {
                        this.planFundEmpty();
                        return;
                    }
                    // 初始化选中智慧定投基金
                    if (_this.recommendFund.length > 0) {
                        _this.wisdomFund = _this.recommendFund[0].fundcode;
                    } else {
                        _this.wisdomFund = "10";
                        _this.fundCode = _this.fundArr[0].fundcode;
                    }
                }
            });
        },
        // 查询推荐智能定投基金
        getRecommendFund () {
            const _this = this;
            this.$util.request("trade/fund/recommended", { type: "3" }).then(res => {
                if (res.data) {
                    _this.recommendFund = res.data;
                }
                this.getGeneralFund();
            });
        },
        // 下级组件回调，显示或隐藏基金列表
        backFn (val) {
            if (val) {
                this.getGeneralFund();
            }
            this.showList = val;
        },
        // 没有可以定投基金提示
        planFundEmpty () {
            this.$alert("当前未查询到可用的智慧定投基金，请联系客服。", "智慧定投提示", {
                confirmButtonText: "返回首页",
                customClass: "info-check",
                type: "warning",
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        this.$router.push({ name: "home" });
                        done();
                    }
                }
            }).then(() => {
                return false;
            }).catch(() => {
                return false;
            });
        },
        // 获取选中智慧定投基金
        getSelFund (all, code, flag) {
            const _fund = all.filter(item => {
                return code === item.fundcode;
            })[0];
            _fund.proto = "plan";
            this.$util.fundRiskCheck(this, _fund, res => {
                if (res) {
                    // 推荐基金标志
                    if (flag) {
                        res.recommend = "1";
                    }
                    const _x = Object.assign({}, res, { way: "59" });
                    this.selFund = Object.assign({}, _x);
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-wisdom-buy {
    .wisdom-con {
        width: 100%;
        .el-radio + .el-radio {
            margin-left: 0;
        }
    }
    .line-padding {
        height: 12px;
        background-color: $bg1;
    }
    .comp-plan-buy {
        .pwdForm {
            padding-top: 40px;
        }
    }
    .wisdom-con {
        .el-radio {
            margin-right: 0;
            display: block;
            position: relative;
            border-bottom: 1px solid #f0f0f0;
            text-align: center;
            .code {
                width: 0;
                height: 0;
                position: absolute;
                left: 0;
                top: 0;
                border: 23px solid $color-c;
                border-right-color: transparent;
                border-bottom-color: transparent;
                i {
                    font-size: $f12;
                    font-style: normal;
                    position: absolute;
                    -ms-transform: rotate(-45deg);
                    transform: rotate(-45deg);
                    top: -12px;
                    left: -21px;
                    color: #ffffff;
                }
            }
            &.tit {
                background-color: #f6fafd;

                .el-radio__input {
                    visibility: hidden;
                }
            }
            .el-radio__label {
                display: inline-block;
                vertical-align: middle;
                width: 1060px;
            }
            .el-radio__input {
                width: 86px;
                display: inline-block;
                padding-left: 40px;
            }
        }
        .wisdom-list {
            padding: 12px 0;
            line-height: 32px;
            color: $text-color2;
            &.my-wisdom {
                padding: 8px 0;
                line-height: 40px;
                .el-select {
                    margin: 0 20px;
                }
            }
        }
    }
}
</style>
